import styled from "styled-components";
import { motion } from "framer-motion";

export const ButtonWhatsApp = styled(motion.div)`
    a {
        position: fixed;
        width: 60px;
        height: 60px;
        bottom: 24px;
        right: 24px;
        background-color: var(--cta-green);
        color: var(--text-primary);
        border-radius: 50px;
        text-align: center;
        font-size: 30px;
        border: 1px solid rgba(255, 255, 255, 0.14);
        box-shadow: var(--shadow-soft);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background-color: var(--cta-green-hover);
            transform: translateY(-2px);
        }
    }
`
